define('modules/media_picker/media_picker_collection_item_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/animation/transition-end',

  'modules/util/collection/collection_view',

  'text!./media_picker_item_template.html',
  'text!./media_picker_header_template.html'
], function (Backbone, $, _, session,
             transitionEnd,
             CollectionView,
             item_template,
             header_template) {
  'use strict';
  var View = Backbone.View.extend({
      initialize: function (opts) {
        _.extend(this, opts);
        // this.model.set(this.extraParams, {silent: true});
        this.render();
      },

      subViews: [],
      tagName: 'li',

      item_template: _.template(item_template),

      events: {
        'click .js-pick-media': 'pickMedia',
        'click .js-show-format': 'showFormat'
      },

      render: function () {
        
        if (!this.model.get('gtin')) {
          this.model.set('gtin', '');
        }
        this.$el.html(this.item_template(this.model.toJSON()));
        return this;
      },

      closePreview: function () {
        session.unset('current_preview');
        this.$el.removeClass('is-active');
        this.$('.js-preview-container').removeClass('is-open');
      },

      pickMedia: function (e) {
        this.extraParams.onSelect(this.model);
      },

      showFormat: function (e) {
        this.$('#toggle-format-preview').toggle();
        this.$('#show-format-button').toggleClass('selected');
        this.$('#show-format-button > .icon').toggleClass('icon-preview');
        this.$('#show-format-button > .icon').toggleClass('icon-preview-white');
        var that = this;
        $(document).one('click', function() {
          that.$('#toggle-format-preview').toggle();
          that.$('#show-format-button').toggleClass('selected');
          that.$('#show-format-button > .icon').addClass('icon-preview');
          that.$('#show-format-button > .icon').removeClass('icon-preview-white');
        });
      },

      remove: function () {
        _.each(this.subViews, function (view) {
          if (view && view.remove) {
            view.remove();
          }
        });
        this.$el.off();
        this.$el.remove();
        this.stopListening();
        return this;
      }

    },

    {
      header: function (collection) {
        if (collection) {
          return _.template(header_template)(collection.params);
        }
      },

      viewTypes: ['grid']

    });
  return View;
});

